import React from "react"
import { useTranslation } from "react-i18next"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@f2e/ui/components/base"

export type HumanModeFilterValue = "no_filter" | "active" | "inactive"

export interface HumanModeSelectProps {
  value?: HumanModeFilterValue
  compact?: boolean
  onHumanModeChange?: (value: HumanModeFilterValue) => void
}

const HumanModeSelect = ({
  value = "no_filter",
  compact = false,
  onHumanModeChange,
}: HumanModeSelectProps) => {
  const { t } = useTranslation()

  const triggerId = "human-mode-select"
  return (
    <div
      className={compact ? "grid gap-1.5" : "mb-4 flex items-center space-x-4"}
    >
      <label
        htmlFor={triggerId}
        className={
          compact ? "text-xs font-medium text-muted-foreground" : "font-medium"
        }
      >
        {t("historyList.humanModeSelect.label")}
      </label>
      <Select
        onValueChange={(value) =>
          onHumanModeChange?.(value as HumanModeFilterValue)
        }
        value={value}
      >
        <SelectTrigger
          id={triggerId}
          className={compact ? "h-9 w-full min-w-0 text-sm" : "w-[180px]"}
        >
          <SelectValue
            placeholder={t("historyList.humanModeSelect.placeholder")}
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="no_filter" className="pl-6">
            {t("historyList.humanModeSelect.none")}
          </SelectItem>
          <SelectItem value="active" className="pl-6">
            {t("historyList.humanModeSelect.active")}
          </SelectItem>
          <SelectItem value="inactive" className="pl-6">
            {t("historyList.humanModeSelect.inactive")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

export default React.memo(HumanModeSelect)
